import React from "react";
import UserWalletComponent from "../../../components/private/user/userWallet/userWalletComponent";

function UserWalletContainer() {
  return <UserWalletComponent />;
}

export default UserWalletContainer;
